<script setup lang="ts">
  import { Talk } from "~/entities/Talk";

  interface Props {
    talk: Talk;
  }
  const props = defineProps<Props>();

  interface Emits {
    (event: "click"): void;
  }
  const emit = defineEmits<Emits>();

  const count = computed(() => {
    return props.talk.threadComments;
  });

  const latestDate = computed(() => {
    const date = props.talk.threadLatestDate ?? new Date();
    return (count.value > 1 ? "最新投稿 : " : "") + FormatDateString(date, "MM/dd HH:mm");
  });
</script>

<template>
  <div class="d-flex cursor-pointer mt-2 mb-4" @click="emit('click')">
    <div class="thread-comments mx-4">{{ count }} コメント</div>
    <div class="thread-latest-date mx-2">
      {{ latestDate }}
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .thread-comments {
    color: rgb(var(--v-theme-primary));
    font-size: 12px;
  }
  .thread-latest-date {
    color: rgb(var(--v-theme-monochrome-02));
    font-size: 12px;
  }
</style>
